module.exports = __webpack_public_path__ + "img/chips.e80efa82.png";